import type { ChatSearchErrorKind } from '../hooks/useChatMessageSearch';

interface SearchErrorStateProps {
  kind: ChatSearchErrorKind | null;
}

/**
 * The one place a failed chat search is explained, so the two panels say the
 * same thing for the same failure: too broad (add words), rate limited (wait),
 * filters refused by an older API (drop the filters), or a plain failure.
 */
export function SearchErrorState({ kind }: SearchErrorStateProps) {
  switch (kind) {
    case 'tooBroad':
      return (
        <div className="text-center py-10 px-6">
          <p className="text-sm text-muted-foreground">That search matches too many messages</p>
          <p className="text-xs text-muted-foreground/70 mt-1">
            Add more words, use a longer phrase, or pick a sender under “From”.
          </p>
        </div>
      );
    case 'rateLimited':
      return (
        <div className="text-center py-10 px-6">
          <p className="text-sm text-muted-foreground">Too many searches in a row</p>
          <p className="text-xs text-muted-foreground/70 mt-1">Wait a moment, then search again.</p>
        </div>
      );
    case 'unsupportedFilters':
      return (
        <div className="text-center py-10 px-6">
          <p className="text-sm text-muted-foreground">Filters aren&apos;t available yet</p>
          <p className="text-xs text-muted-foreground/70 mt-1">
            Clear the “Has” and date filters to search; they need a newer server.
          </p>
        </div>
      );
    default:
      return (
        <p className="text-sm text-destructive text-center py-10">
          Couldn&apos;t run that search. Try again.
        </p>
      );
  }
}
